var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.10927 0.5H21.8905C22.2152 0.5 22.5191 0.58042 22.7942 0.712974L13.4912 10.0377C12.6687 10.8663 11.3311 10.8663 10.5085 10.0377L1.20557 0.712974C1.48058 0.58042 1.78456 0.5 2.10927 0.5ZM16.51 9.00013L23.7886 1.71468C23.9202 1.99174 24 2.29797 24 2.62508V15.3752C24 15.7022 23.9202 16.0085 23.7886 16.2856L16.51 9.00013ZM0.211406 1.71468C0.0798279 1.99174 0 2.29797 0 2.62508V15.3752C0 15.7023 0.0798279 16.0086 0.211406 16.2856L7.49009 9.00013L0.211406 1.71468ZM14.4855 11.0392L15.5155 10.0016L22.7942 17.2871C22.5191 17.4196 22.2152 17.5001 21.8905 17.5001H2.10927C1.78456 17.5001 1.48058 17.4196 1.20557 17.2871L8.48425 10.0016L9.51418 11.0392C10.8848 12.42 13.1149 12.42 14.4855 11.0392Z",
    fill: "#2D448D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.f6237e4d.svg";
export { ForwardRef as ReactComponent };